import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import PreviewListComponent from "./PreviewListComponent";
import PreviewComponent from "./PreviewComponent";

import { fetchFileAndConvertToBase64 } from "../../../Shared/Utils/filesUtils";
export default function DropLayoutComponent({
  input,
  readOnly,
  dropzoneProps,
  files,
  extra: { maxFiles },
  handleDelete,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleFileClick = (file) => {
    if (file?.data == undefined) {
      fetchFileAndConvertToBase64(file, handleConverFile);
    } else {
      setSelectedFile(file);
      setModalOpen(true);
    }
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleConverFile = async (file) => {
    setSelectedFile(file);
    setModalOpen(true);
  };

  return (
    <div>
      {!readOnly && (
        <div {...dropzoneProps}>{files.length < maxFiles && input}</div>
      )}

      <PreviewListComponent
        files={files}
        handleFileClick={handleFileClick}
        handleDelete={handleDelete}
        readOnly={readOnly}
      ></PreviewListComponent>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalBody>
          <PreviewComponent selectedFile={selectedFile}></PreviewComponent>
        </ModalBody>
      </Modal>
    </div>
  );
}
